var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "p-7", attrs: { tile: "" } },
    [
      _c(
        "div",
        { staticClass: "close-popup" },
        [
          _c(
            "v-btn",
            {
              attrs: { icon: "", small: "" },
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            },
            [_c("v-icon", { attrs: { small: "" } }, [_vm._v(" mdi-close ")])],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "flex justify-center" },
        [
          _c(
            "v-icon",
            { staticClass: "w-10", attrs: { color: "error", size: "40" } },
            [_vm._v(" mdi-delete ")]
          ),
        ],
        1
      ),
      _c("span", { staticClass: "font-medium text-center mt-7 mb-2" }, [
        _vm._v(" คุณต้องการลบข้อมูล? "),
      ]),
      _vm.canRemove
        ? _c("span", { staticClass: "text-field-gray text-sm text-center" }, [
            _vm._v(" ระบบจะลบข้อมูลทั้งหมดที่คุณเลือก "),
          ])
        : _c("div", { staticClass: "error--text text-center" }, [
            _vm._v(" " + _vm._s(_vm.canNotRemoveMessage) + " "),
          ]),
      _c("v-divider", { staticClass: "my-7" }),
      _c(
        "div",
        { staticClass: "flex justify-end gap-4" },
        [
          _c(
            "v-btn",
            {
              attrs: { color: "blue darken-1", text: "" },
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            },
            [_vm._v(" ยกเลิก ")]
          ),
          _vm.canRemove
            ? _c(
                "v-btn",
                {
                  attrs: {
                    color: "error",
                    depressed: "",
                    rounded: "",
                    dark: !_vm.loading,
                    disabled: _vm.loading,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("confirm")
                    },
                  },
                },
                [
                  _vm.loading
                    ? _c("v-progress-circular", {
                        staticClass: "mr-2",
                        attrs: { size: "16", width: "2", indeterminate: "" },
                      })
                    : _vm._e(),
                  _vm._v(" ยืนยันลบข้อมูล "),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }